import { render, staticRenderFns } from "./PageHRDocument.vue?vue&type=template&id=5b291196&"
import script from "./PageHRDocument.vue?vue&type=script&lang=js&"
export * from "./PageHRDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports